import { recoveryPasswordService } from '../../../services/auth/recoveyPassword';

export function RecoveryPasswordAction (user) {
	return {
		type: 'RECOVERY_PASSWORD',
		payload: recoveryPasswordService(user)
	}
}